import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer, colorBins } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const DENSITYHOUSEHOLDSACREDIFFINVANY_LAYER_ID =
  'densityHouseholdsAcreDiffInvAnyLayer';

const layerConfig = {
  title: 'Density Households Acre Difference',
};

function DensityHouseholdsAcreDiffInvAnyLayer() {
  const dispatch = useDispatch();
  const { densityHouseholdsAcreDiffInvAnyLayer } = useSelector(
    (state) => state.carto.layers
  );
  const source = useSelector((state) =>
    selectSourceById(state, densityHouseholdsAcreDiffInvAnyLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (densityHouseholdsAcreDiffInvAnyLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: DENSITYHOUSEHOLDSACREDIFFINVANY_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: densityHouseholdsAcreDiffInvAnyLayer.visible,
      opacity: densityHouseholdsAcreDiffInvAnyLayer.opacity,
      getFillColor: colorBins({
        attr: 'density_households_acre_diff',
        domain: [-4, -2.25, 0, 0.04, 5, 12],
        colors: [
          [178, 34, 34],
          [255, 0, 0],
          [255, 102, 102],
          [180, 210, 255],
          [153, 204, 255],
          [51, 153, 255],
          [51, 102, 255],
        ],
      }),
      pointRadiusMinPixels: 5,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: DENSITYHOUSEHOLDSACREDIFFINVANY_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              includeColumns: ['density_households_acre_diff', 'geo_level_id'],
            }),
          };
        }
      },
    });
  }
}

export default DensityHouseholdsAcreDiffInvAnyLayer;
